import { useSelector } from '@xstate/react'
import * as React from 'react'
import { InterpreterFrom, StateFrom } from 'xstate'

import { authMachine } from '../service/authMachine'

type TAuthState = StateFrom<typeof authMachine>

const guestSelector = (state: TAuthState) => state.matches('guest')
const userSelector = (state: TAuthState) => state.matches('user')
const failedSelector = (state: TAuthState) => state.matches('failed')

type TOptions = {
  machine: InterpreterFrom<typeof authMachine>
}

/**
 * Returns state values of the `authMachine`
 */
export const useAuthStateValues = ({ machine }: TOptions) => {
  const isGuest = useSelector(machine, guestSelector)
  const isLoggedIn = useSelector(machine, userSelector)
  const isFailed = useSelector(machine, failedSelector)

  const contextValues = React.useMemo(() => {
    const isValid = isGuest || isLoggedIn

    return { isGuest, isLoggedIn, isValid, isFailed }
  }, [isFailed, isGuest, isLoggedIn])

  return contextValues
}
